module.exports = __webpack_public_path__ + "img/Stockroom Icon_Up.34fe1b4c.svg";